export default {
  headerTitle: 'ETZ Profile',
  exportCsvButton: 'Export CSV',
};
